import type { Component } from "solid-js";
import { useTranslation } from "../../../state/i18n";
import type { Webhook } from "../../../types/Webhook";
import { upsertWebhookSchema } from "../../../types/Webhook";
import { TextInput } from "../../../components/inputs/TextInput";
import { MultiSelectInput } from "../../../components/menu/MultiSelect";
import { isEmpty } from "lodash-es";
import type { InputModalProps } from "../../../components/modal/InputModal";
import InputModal from "../../../components/modal/InputModal";
import type { InferOutput } from "valibot";
import { WEBHOOK_EVENT_TYPES } from "../../../constants";

type UpsertWebhookModalProps = {
  webhook?: Webhook;
} & Pick<InputModalProps<InferOutput<typeof upsertWebhookSchema>>, "title" | "onConfirm" | "confirmLabel">;
const UpsertWebhookModal: Component<UpsertWebhookModalProps> = (props) => {
  const { t } = useTranslation();

  return (
    <InputModal
      variant="default"
      size="large"
      title={props.title}
      titleIcon="pencilAlt"
      confirmLabel={props.confirmLabel}
      cancelLabel={t(($) => $.SETTINGS_WEBHOOKS_UPSERT_MODAL_ACTIONS_CANCEL)}
      onConfirm={props.onConfirm}
      schema={upsertWebhookSchema}
      initialValue={{
        name: props.webhook?.name,
        url: props.webhook?.url,
        type: props.webhook?.type,
      }}
    >
      {({ value, updateValue, error }) => (
        <div class="flex flex-col gap-4">
          <TextInput
            label={t(($) => $.SETTINGS_WEBHOOKS_UPSERT_MODAL_INPUT_NAME)}
            value={value("name")}
            required
            onBlur={(e) => {
              updateValue("name", e.target.value);
            }}
            onInput={(e) => {
              updateValue("name", e.target.value);
            }}
            errorMessage={error("name")}
          />
          <TextInput
            label={t(($) => $.SETTINGS_WEBHOOKS_UPSERT_MODAL_INPUT_URL)}
            value={value("url")}
            required
            onBlur={(e) => {
              updateValue("url", e.target.value);
            }}
            onInput={(e) => {
              updateValue("url", e.target.value);
            }}
            errorMessage={error("url")}
          />

          <MultiSelectInput
            label={t(($) => $.SETTINGS_WEBHOOKS_UPSERT_MODAL_INPUT_EVENTS)}
            value={value("type")}
            required
            sameWidth
            options={WEBHOOK_EVENT_TYPES.map((type) => ({
              variant: "text",
              label: type,
              value: type,
            }))}
            onSelect={(value) => {
              isEmpty(value) ? updateValue("type", undefined) : updateValue("type", value);
            }}
            errorMessage={error("type")}
          />
        </div>
      )}
    </InputModal>
  );
};

export default UpsertWebhookModal;
